<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte de Ventas</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.sucursalOrigenId"
              :items="listSucursales"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Originada en"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.canalesVentaId"
              :items="listCanalesVenta"
              autocomplete="disabled"
              multiple
              item-text="nombre"
              item-value="id"
              label="del Canal de Venta"
              placeholder="Dejar en blanco para Todos"
              :menu-props="{ minWidth: '400' }"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="6" lg="3">
            <v-select
              label="Origen:"
              v-model="filtro.tipoCanalVentaId"
              :items="tiposCanalVenta"
              item-text="descripcion"
              item-value="id"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.productoId"
              :items="listProductos"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Producto"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Liquidados Desde"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Liquidados Hasta"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.sucursalLiquidacionId"
              :items="listSucursales"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Liquidado en"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.ejecutivo"
              :items="listEjecutivos"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="descripcion"
              label="Ejecutivo"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <span class="title">Opciones</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="10" lg="6">
            <v-radio-group
              v-model="filtro.agrupamiento"
              :mandatory="true"
              label="Agrupar por"
              row
            >
              <v-radio value="0">
                <div slot="label">Producto/Plan</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Tipo Cliente/Producto/Plan</div>
              </v-radio>
              <!-- <v-radio value="2">
                                <div slot="label"> Vendida</div>
                            </v-radio> -->
            </v-radio-group>
          </v-col>
          <v-col cols="6" lg="3">
            <v-switch v-model="filtro.resumido" label="Resumido"></v-switch>
          </v-col>
          <v-col cols="2" lg="1">
            <v-text-field
              v-model="filtro.separador"
              label="Separador en archivo"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn dark color="green" @click="procesarBase">
          Descargar Archivo&nbsp;
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        sucursalOrigenId: 0,
        canalesVenta: '',
        tipoCanalVentaId: 0,
        sucursalLiquidacionId: 0,
        productoId: 0,
        agrupamiento: 0,
        resumido: false,
        fechaDesde: null,
        fechaHasta: null,
        ejecutivo: '(Todos)',
        separador: ';',
      },
      listEmpresas: [],
      listSucursales: [],
      listCanalesVenta: [],
      listProductos: [],
      tiposCanalVenta: [],
      listEjecutivos: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadCanalesVenta();
    this.loadProductos();
    this.loadTiposCanalVenta();
    this.loadEjecutivos();

    this.filtro.fechaDesde = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );
        this.listEmpresas = result.list;
        this.listEmpresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.listSucursales = result.list;

        this.listSucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.listCanalesVenta = result.list;
        //this.listCanalesVenta.unshift({id:0,nombre:'(Todos)'});
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.listProductos = result.list;
        this.listProductos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposCanalVenta() {
      this.loading = true;
      try {
        var result = await http.get('tiposcanalventa');
        this.tiposCanalVenta = result.list;
        this.tiposCanalVenta.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadEjecutivos() {
      this.loading = true;
      try {
        var result = await http.get('ejecutivos');

        this.listEjecutivos = result.list;
        this.listEjecutivos.unshift({ id: '(Todos)', descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (!this.filtro.fechaDesde) {
        this.alertWarning('Debe ingresar la Fecha de Cobranza Desde.');
        return false;
      }

      if (!this.filtro.fechaHasta) {
        this.alertWarning('Debe ingresar la Fecha de Cobranza Hasta.');
        return false;
      }

      return true;
    },
    async procesarReporte() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      let canalVentaNombre = '';

      //Si se eligió TODOS
      if (
        !this.filtro.canalesVentaId ||
        this.filtro.canalesVentaId.length == 0
      ) {
        canalVentaNombre = 'Todos';
        //Si no tiene acceso a todos los canaes armo un string con todos los canales de venta habilitados para el usuario.
        if (!this.$store.state.user.accesoTodosCanalesVenta) {
          this.filtro.canalesVenta = this.listCanalesVenta
            .map((cv) => cv.id)
            .join();
        }
        // si no lo pongo en 0
        else {
          this.filtro.canalesVenta = 0;
        }
      }
      //si se eligió un filtro mando ese
      else {
        canalVentaNombre =
          this.filtro.canalesVentaId.length > 1
            ? 'Varios'
            : this.listCanalesVenta.find(
                (cv) => cv.id == this.filtro.canalesVentaId[0]
              ).nombre;
        this.filtro.canalesVenta = this.filtro.canalesVentaId.toString();
      }

      try {
        self.loading = true;

        console.log(this.filtro.productoId);

        let params = [];
        params.push({
          Version: this.$store.state.version,
          EmpresaId: this.filtro.empresaId,
          ProductoId: this.filtro.productoId,
          SucursalOrigenId: this.filtro.sucursalOrigenId,
          CanalesVenta: this.filtro.canalesVenta.toString(),
          FechaDesde: this.filtro.fechaDesde,
          FechaHasta: this.filtro.fechaHasta,
          EmpresaNombre: this.listEmpresas.find(
            (i) => i.id == this.filtro.empresaId
          ).nombre,
          CanalVentaDescripcion: canalVentaNombre,
          SucursalDescripcion: this.listSucursales.find(
            (i) => i.id == this.filtro.sucursalLiquidacionId
          ).nombre,
          Resumido: this.filtro.resumido,
          SucursalLiquidacionId: this.filtro.sucursalLiquidacionId,
          TipoCanalVentaId: this.filtro.tipoCanalVentaId,
          Ejecutivo: this.filtro.ejecutivo,
        });

        if (this.filtro.agrupamiento == 0) {
          this.setReporteActivo({
            reporte: 'Ventas por Producto y Plan.trdp',
            params: params,
          });
          window.open('/report-viewer');
        }

        if (this.filtro.agrupamiento == 1) {
          this.setReporteActivo({
            reporte: 'Ventas por TipoCliente Producto y Plan.trdp',
            params: params,
          });
          window.open('/report-viewer');
        }
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async procesarBase() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      //Si se eligió TODOS
      if (
        !this.filtro.canalesVentaId ||
        this.filtro.canalesVentaId.length == 0
      ) {
        //Si no tiene acceso a todos los canales armo un string con todos los canales de venta habilitados para el usuario.
        if (!this.$store.state.user.accesoTodosCanalesVenta) {
          this.filtro.canalesVenta = this.listCanalesVenta
            .map((cv) => cv.id)
            .join();
        }
        // si no lo pongo en 0
        else {
          this.filtro.canalesVenta = 0;
        }
      }
      //si se eligió un filtro mando ese
      else {
        this.filtro.canalesVenta = this.filtro.canalesVentaId.toString();
      }

      try {
        self.loading = true;

        await http
          .post(
            'filegeneration/ventas',
            JSON.stringify({ parametros: this.filtro })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                'Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...'
              );

              self.loading = true;
              self.downloadFile(resp, 'ReporteDeVentas.csv');
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = '';
      base64String = btoa(file.fullPath);

      http
        .get('filemanagement/getfilebypath/' + base64String)
        .then((resp) => {
          let dataType = '';
          switch (resp.extension) {
            case '.doc':
            case '.docx':
            case '.DOC':
            case '.DOCX':
              dataType = 'data:application/vnd.ms-word';
              break;
            case '.pdf':
            case '.PDF':
              dataType = 'data:application/pdf';
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};
</script>
